import React from "react";

export const PrivacyPolicy: React.FC<any> = () => {
    return (
        <React.Fragment>
          <div style={{ maxWidth: '900px', margin: '0 auto', paddingTop: '2rem' }}>
            {/* Header */}
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
              Privacy Policy
            </h1>
            <p style={{ fontSize: '1rem', color: 'var(--ion-color-medium, #666)', marginBottom: '2rem' }}>
              <strong>Last Updated:</strong> March 11, 2026
            </p>

            {/* Introduction */}
            <section style={{ marginBottom: '3rem' }}>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                WerkApp ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains 
                how we collect, use, disclose, and safeguard your information when you use our mobile application 
                and web portal (collectively, the "Service").
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                Please read this Privacy Policy carefully. By accessing or using the Service, you agree to the 
                collection and use of information in accordance with this policy.
              </p>
            </section>

            {/* 1. Information We Collect */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                1. Information We Collect
              </h2>
              
              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                1.1 Personal Information
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                When you create an account, we may collect:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Profile photo (optional)</li>
                <li>Job title and department affiliation</li>
                <li>Payment information (processed securely through third-party payment processors)</li>
              </ul>

              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                1.2 Usage Information
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We automatically collect information about how you use the Service, including:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>Device information (device type, operating system, unique device identifiers)</li>
                <li>Log data (IP address, access times, pages viewed)</li>
                <li>Location information (with your permission)</li>
                <li>Job postings, acceptances, and scheduling activity</li>
                <li>Communications sent through the Service</li>
              </ul>

              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                1.3 Cookies and Tracking Technologies
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                We use cookies, web beacons, and similar tracking technologies to track activity on our Service 
                and store certain information to improve functionality and user experience.
              </p>
            </section>

            {/* 2. How We Use Your Information */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                2. How We Use Your Information
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We use the information we collect to:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem' }}>
                <li>Provide, maintain, and improve the Service</li>
                <li>Create and manage your account</li>
                <li>Facilitate job postings, notifications, and scheduling</li>
                <li>Process payments and subscriptions</li>
                <li>Send you notifications about job opportunities, schedule changes, and Service updates</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Monitor and analyze usage patterns to improve user experience</li>
                <li>Detect, prevent, and address technical issues and fraudulent activity</li>
                <li>Comply with legal obligations and enforce our Terms of Service</li>
              </ul>
            </section>

            {/* 3. Information Sharing and Disclosure */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                3. Information Sharing and Disclosure
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We do not sell your personal information. We may share your information in the following circumstances:
              </p>
              
              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                3.1 With Other Users
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                Your profile information (name, photo, job title) is visible to other users within your network or 
                department to facilitate job scheduling and coordination.
              </p>

              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                3.2 With Service Providers
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We share information with third-party service providers who perform services on our behalf, such as:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>Cloud hosting providers (Firebase/Google Cloud)</li>
                <li>Payment processors (RevenueCat, Apple, Google)</li>
                <li>Analytics providers</li>
                <li>Customer support tools</li>
              </ul>

              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                3.3 For Legal Reasons
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We may disclose your information if required by law or in response to valid legal requests (e.g., 
                subpoenas, court orders), or to protect the rights, property, and safety of WerkApp, our users, 
                or the public.
              </p>

              <h3 style={{ fontSize: '1.4rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                3.4 Business Transfers
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                If WerkApp is involved in a merger, acquisition, or sale of assets, your information may be 
                transferred as part of that transaction. We will notify you of any such change.
              </p>
            </section>

            {/* 4. Data Security */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                4. Data Security
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We implement industry-standard security measures to protect your personal information, including:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li>Encrypted data transmission (SSL/TLS)</li>
                <li>Secure cloud storage with access controls</li>
                <li>Regular security audits and monitoring</li>
                <li>Limited employee access to personal data on a need-to-know basis</li>
              </ul>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                However, no method of transmission over the Internet or electronic storage is 100% secure. While 
                we strive to protect your information, we cannot guarantee absolute security.
              </p>
            </section>

            {/* 5. Your Rights and Choices */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                5. Your Rights and Choices
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                You have the following rights regarding your personal information:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li><strong>Access and Update:</strong> You can access and update your account information through the app settings.</li>
                <li><strong>Delete:</strong> You can request deletion of your account by contacting us at support@werkapp.app.</li>
                <li><strong>Opt-Out:</strong> You can opt out of promotional emails by following the unsubscribe link in those emails. Note that you cannot opt out of Service-related notifications (e.g., job assignments, schedule changes).</li>
                <li><strong>Data Portability:</strong> You can request a copy of your data in a portable format.</li>
                <li><strong>Withdraw Consent:</strong> Where we rely on your consent to process data, you may withdraw that consent at any time.</li>
              </ul>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                To exercise these rights, please contact us at support@werkapp.app.
              </p>
            </section>

            {/* 6. Data Retention */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                6. Data Retention
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                We retain your personal information for as long as necessary to provide the Service, comply with 
                legal obligations, resolve disputes, and enforce our agreements. When you delete your account, we 
                will delete or anonymize your personal information within 90 days, except where we are required to 
                retain it for legal or regulatory purposes.
              </p>
            </section>

            {/* 7. Children's Privacy */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                7. Children's Privacy
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                The Service is not intended for use by individuals under the age of 18. We do not knowingly collect 
                personal information from children. If you believe we have collected information from a child, please 
                contact us immediately so we can delete it.
              </p>
            </section>

            {/* 8. International Data Transfers */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                8. International Data Transfers
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                Your information may be transferred to and processed in countries other than your country of residence. 
                These countries may have data protection laws that differ from those in your jurisdiction. By using 
                the Service, you consent to such transfers.
              </p>
            </section>

            {/* 9. Changes to This Privacy Policy */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                9. Changes to This Privacy Policy
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                We may update this Privacy Policy from time to time. When we make changes, we will update the "Last 
                Updated" date at the top of this page and notify you through the Service or via email. Your continued 
                use of the Service after such changes constitutes acceptance of the updated policy.
              </p>
            </section>

            {/* 10. Contact Us */}
            <section style={{ marginBottom: '3rem', backgroundColor: 'var(--ion-color-light, #f5f5f5)', padding: '2rem', borderRadius: '8px' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                10. Contact Us
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, 
                please contact us at:
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                <strong>WerkApp Support</strong><br />
                Email: support@werkapp.app<br />
                Website: werkapp.app
              </p>
            </section>

            {/* Footer Note */}
            <section style={{ marginBottom: '3rem', textAlign: 'center' }}>
              <p style={{ fontSize: '0.95rem', color: 'var(--ion-color-medium, #999)', fontStyle: 'italic' }}>
                This Privacy Policy applies to the WerkApp mobile application (iOS and Android) and web portal.
              </p>
            </section>
          </div>
        </React.Fragment>
    )
};


